module.exports = {"350322001":"鲤城街道","350322100":"枫亭镇","350322101":"榜头镇","350322102":"郊尾镇","350322103":"度尾镇","350322104":"鲤南镇","350322105":"赖店镇","350322106":"盖尾镇","350322107":"园庄镇","350322108":"大济镇","350322109":"龙华镇","350322110":"钟山镇","350322111":"游洋镇","350322200":"西苑乡","350322201":"石苍乡","350322202":"社硎乡","350322203":"书峰乡","350322204":"菜溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350322.json
// module id = 1293
// module chunks = 0